import * as e from "react";
import { Fragment as t, jsx as n, jsxs as r } from "react/jsx-runtime";
// ../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.mjs
function i(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") {
		if (Array.isArray(e)) {
			var a = e.length;
			for (t = 0; t < a; t++) e[t] && (n = i(e[t])) && (r && (r += " "), r += n);
		} else for (n in e) e[n] && (r && (r += " "), r += n);
	}
	return r;
}
function a() {
	for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = i(e)) && (r && (r += " "), r += t);
	return r;
}
// ../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.mjs
var o = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, s = a, c = (e, t) => (n) => {
	if (t?.variants == null) return s(e, n?.class, n?.className);
	let { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((e) => {
		let t = n?.[e], a = i?.[e];
		if (t === null) return null;
		let s = o(t) || o(a);
		return r[e][s];
	}), c = n && Object.entries(n).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return s(e, a, t?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...a } = t;
		return Object.entries(a).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...i,
				...c
			}[t]) : {
				...i,
				...c
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), n?.class, n?.className);
}, l = "-", u = (e) => {
	let t = m(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			let n = e.split(l);
			return n[0] === "" && n.length !== 1 && n.shift(), d(n, t) || p(e);
		},
		getConflictingClassGroupIds: (e, t) => {
			let i = n[e] || [];
			return t && r[e] ? [...i, ...r[e]] : i;
		}
	};
}, d = (e, t) => {
	if (e.length === 0) return t.classGroupId;
	let n = e[0], r = t.nextPart.get(n), i = r ? d(e.slice(1), r) : void 0;
	if (i) return i;
	if (t.validators.length === 0) return;
	let a = e.join(l);
	return t.validators.find(({ validator: e }) => e(a))?.classGroupId;
}, f = /^\[(.+)\]$/, p = (e) => {
	if (f.test(e)) {
		let t = f.exec(e)[1], n = t?.substring(0, t.indexOf(":"));
		if (n) return "arbitrary.." + n;
	}
}, m = (e) => {
	let { theme: t, prefix: n } = e, r = {
		nextPart: /* @__PURE__ */ new Map(),
		validators: []
	};
	return v(Object.entries(e.classGroups), n).forEach(([e, n]) => {
		h(n, r, e, t);
	}), r;
}, h = (e, t, n, r) => {
	e.forEach((e) => {
		if (typeof e == "string") {
			let r = e === "" ? t : g(t, e);
			r.classGroupId = n;
		} else if (typeof e == "function") {
			if (_(e)) {
				h(e(r), t, n, r);
				return;
			}
			t.validators.push({
				validator: e,
				classGroupId: n
			});
		} else Object.entries(e).forEach(([e, i]) => {
			h(i, g(t, e), n, r);
		});
	});
}, g = (e, t) => {
	let n = e;
	return t.split(l).forEach((e) => {
		n.nextPart.has(e) || n.nextPart.set(e, {
			nextPart: /* @__PURE__ */ new Map(),
			validators: []
		}), n = n.nextPart.get(e);
	}), n;
}, _ = (e) => e.isThemeGetter, v = (e, t) => t ? e.map(([e, n]) => [e, n.map((e) => typeof e == "string" ? t + e : typeof e == "object" ? Object.fromEntries(Object.entries(e).map(([e, n]) => [t + e, n])) : e)]) : e, y = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), i = (i, a) => {
		n.set(i, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
	};
	return {
		get(e) {
			let t = n.get(e);
			if (t !== void 0) return t;
			if ((t = r.get(e)) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			n.has(e) ? n.set(e, t) : i(e, t);
		}
	};
}, b = "!", x = (e) => {
	let { separator: t, experimentalParseClassName: n } = e, r = t.length === 1, i = t[0], a = t.length, o = (e) => {
		let n = [], o = 0, s = 0, c;
		for (let l = 0; l < e.length; l++) {
			let u = e[l];
			if (o === 0) {
				if (u === i && (r || e.slice(l, l + a) === t)) {
					n.push(e.slice(s, l)), s = l + a;
					continue;
				}
				if (u === "/") {
					c = l;
					continue;
				}
			}
			u === "[" ? o++ : u === "]" && o--;
		}
		let l = n.length === 0 ? e : e.substring(s), u = l.startsWith(b);
		return {
			modifiers: n,
			hasImportantModifier: u,
			baseClassName: u ? l.substring(1) : l,
			maybePostfixModifierPosition: c && c > s ? c - s : void 0
		};
	};
	return n ? (e) => n({
		className: e,
		parseClassName: o
	}) : o;
}, S = (e) => {
	if (e.length <= 1) return e;
	let t = [], n = [];
	return e.forEach((e) => {
		e[0] === "[" ? (t.push(...n.sort(), e), n = []) : n.push(e);
	}), t.push(...n.sort()), t;
}, C = (e) => ({
	cache: y(e.cacheSize),
	parseClassName: x(e),
	...u(e)
}), w = /\s+/, T = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i } = t, a = [], o = e.trim().split(w), s = "";
	for (let e = o.length - 1; e >= 0; --e) {
		let t = o[e], { modifiers: c, hasImportantModifier: l, baseClassName: u, maybePostfixModifierPosition: d } = n(t), f = !!d, p = r(f ? u.substring(0, d) : u);
		if (!p) {
			if (!f || (p = r(u), !p)) {
				s = t + (s.length > 0 ? " " + s : s);
				continue;
			}
			f = !1;
		}
		let m = S(c).join(":"), h = l ? m + b : m, g = h + p;
		if (a.includes(g)) continue;
		a.push(g);
		let _ = i(p, f);
		for (let e = 0; e < _.length; ++e) {
			let t = _[e];
			a.push(h + t);
		}
		s = t + (s.length > 0 ? " " + s : s);
	}
	return s;
};
function E() {
	let e = 0, t, n, r = "";
	for (; e < arguments.length;) (t = arguments[e++]) && (n = D(t)) && (r && (r += " "), r += n);
	return r;
}
var D = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = D(e[r])) && (n && (n += " "), n += t);
	return n;
};
function O(e, ...t) {
	let n, r, i, a = o;
	function o(o) {
		return n = C(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o);
	}
	function s(e) {
		let t = r(e);
		if (t) return t;
		let a = T(e, n);
		return i(e, a), a;
	}
	return function() {
		return a(E.apply(null, arguments));
	};
}
var k = (e) => {
	let t = (t) => t[e] || [];
	return t.isThemeGetter = !0, t;
}, A = /^\[(?:([a-z-]+):)?(.+)\]$/i, j = /^\d+\/\d+$/, M = /*#__PURE__*/ new Set([
	"px",
	"full",
	"screen"
]), N = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, P = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, F = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, I = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, L = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, R = (e) => B(e) || M.has(e) || j.test(e), z = (e) => q(e, "length", oe), B = (e) => !!e && !Number.isNaN(Number(e)), V = (e) => q(e, "number", B), H = (e) => !!e && Number.isInteger(Number(e)), ee = (e) => e.endsWith("%") && B(e.slice(0, -1)), U = (e) => A.test(e), W = (e) => N.test(e), G = /*#__PURE__*/ new Set([
	"length",
	"size",
	"percentage"
]), te = (e) => q(e, G, se), ne = (e) => q(e, "position", se), re = /*#__PURE__*/ new Set(["image", "url"]), ie = (e) => q(e, re, le), ae = (e) => q(e, "", ce), K = () => !0, q = (e, t, n) => {
	let r = A.exec(e);
	return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, oe = (e) => P.test(e) && !F.test(e), se = () => !1, ce = (e) => I.test(e), le = (e) => L.test(e), ue = /*#__PURE__*/ O(() => {
	let e = k("colors"), t = k("spacing"), n = k("blur"), r = k("brightness"), i = k("borderColor"), a = k("borderRadius"), o = k("borderSpacing"), s = k("borderWidth"), c = k("contrast"), l = k("grayscale"), u = k("hueRotate"), d = k("invert"), f = k("gap"), p = k("gradientColorStops"), m = k("gradientColorStopPositions"), h = k("inset"), g = k("margin"), _ = k("opacity"), v = k("padding"), y = k("saturate"), b = k("scale"), x = k("sepia"), S = k("skew"), C = k("space"), w = k("translate"), T = () => [
		"auto",
		"contain",
		"none"
	], E = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], D = () => [
		"auto",
		U,
		t
	], O = () => [U, t], A = () => [
		"",
		R,
		z
	], j = () => [
		"auto",
		B,
		U
	], M = () => [
		"bottom",
		"center",
		"left",
		"left-bottom",
		"left-top",
		"right",
		"right-bottom",
		"right-top",
		"top"
	], N = () => [
		"solid",
		"dashed",
		"dotted",
		"double",
		"none"
	], P = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], F = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch"
	], I = () => [
		"",
		"0",
		U
	], L = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], G = () => [B, U];
	return {
		cacheSize: 500,
		separator: ":",
		theme: {
			colors: [K],
			spacing: [R, z],
			blur: [
				"none",
				"",
				W,
				U
			],
			brightness: G(),
			borderColor: [e],
			borderRadius: [
				"none",
				"",
				"full",
				W,
				U
			],
			borderSpacing: O(),
			borderWidth: A(),
			contrast: G(),
			grayscale: I(),
			hueRotate: G(),
			invert: I(),
			gap: O(),
			gradientColorStops: [e],
			gradientColorStopPositions: [ee, z],
			inset: D(),
			margin: D(),
			opacity: G(),
			padding: O(),
			saturate: G(),
			scale: G(),
			sepia: I(),
			skew: G(),
			space: O(),
			translate: O()
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				"video",
				U
			] }],
			container: ["container"],
			columns: [{ columns: [W] }],
			"break-after": [{ "break-after": L() }],
			"break-before": [{ "break-before": L() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: [...M(), U] }],
			overflow: [{ overflow: E() }],
			"overflow-x": [{ "overflow-x": E() }],
			"overflow-y": [{ "overflow-y": E() }],
			overscroll: [{ overscroll: T() }],
			"overscroll-x": [{ "overscroll-x": T() }],
			"overscroll-y": [{ "overscroll-y": T() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: [h] }],
			"inset-x": [{ "inset-x": [h] }],
			"inset-y": [{ "inset-y": [h] }],
			start: [{ start: [h] }],
			end: [{ end: [h] }],
			top: [{ top: [h] }],
			right: [{ right: [h] }],
			bottom: [{ bottom: [h] }],
			left: [{ left: [h] }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				"auto",
				H,
				U
			] }],
			basis: [{ basis: D() }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"wrap",
				"wrap-reverse",
				"nowrap"
			] }],
			flex: [{ flex: [
				"1",
				"auto",
				"initial",
				"none",
				U
			] }],
			grow: [{ grow: I() }],
			shrink: [{ shrink: I() }],
			order: [{ order: [
				"first",
				"last",
				"none",
				H,
				U
			] }],
			"grid-cols": [{ "grid-cols": [K] }],
			"col-start-end": [{ col: [
				"auto",
				{ span: [
					"full",
					H,
					U
				] },
				U
			] }],
			"col-start": [{ "col-start": j() }],
			"col-end": [{ "col-end": j() }],
			"grid-rows": [{ "grid-rows": [K] }],
			"row-start-end": [{ row: [
				"auto",
				{ span: [H, U] },
				U
			] }],
			"row-start": [{ "row-start": j() }],
			"row-end": [{ "row-end": j() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": [
				"auto",
				"min",
				"max",
				"fr",
				U
			] }],
			"auto-rows": [{ "auto-rows": [
				"auto",
				"min",
				"max",
				"fr",
				U
			] }],
			gap: [{ gap: [f] }],
			"gap-x": [{ "gap-x": [f] }],
			"gap-y": [{ "gap-y": [f] }],
			"justify-content": [{ justify: ["normal", ...F()] }],
			"justify-items": [{ "justify-items": [
				"start",
				"end",
				"center",
				"stretch"
			] }],
			"justify-self": [{ "justify-self": [
				"auto",
				"start",
				"end",
				"center",
				"stretch"
			] }],
			"align-content": [{ content: [
				"normal",
				...F(),
				"baseline"
			] }],
			"align-items": [{ items: [
				"start",
				"end",
				"center",
				"baseline",
				"stretch"
			] }],
			"align-self": [{ self: [
				"auto",
				"start",
				"end",
				"center",
				"stretch",
				"baseline"
			] }],
			"place-content": [{ "place-content": [...F(), "baseline"] }],
			"place-items": [{ "place-items": [
				"start",
				"end",
				"center",
				"baseline",
				"stretch"
			] }],
			"place-self": [{ "place-self": [
				"auto",
				"start",
				"end",
				"center",
				"stretch"
			] }],
			p: [{ p: [v] }],
			px: [{ px: [v] }],
			py: [{ py: [v] }],
			ps: [{ ps: [v] }],
			pe: [{ pe: [v] }],
			pt: [{ pt: [v] }],
			pr: [{ pr: [v] }],
			pb: [{ pb: [v] }],
			pl: [{ pl: [v] }],
			m: [{ m: [g] }],
			mx: [{ mx: [g] }],
			my: [{ my: [g] }],
			ms: [{ ms: [g] }],
			me: [{ me: [g] }],
			mt: [{ mt: [g] }],
			mr: [{ mr: [g] }],
			mb: [{ mb: [g] }],
			ml: [{ ml: [g] }],
			"space-x": [{ "space-x": [C] }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": [C] }],
			"space-y-reverse": ["space-y-reverse"],
			w: [{ w: [
				"auto",
				"min",
				"max",
				"fit",
				"svw",
				"lvw",
				"dvw",
				U,
				t
			] }],
			"min-w": [{ "min-w": [
				U,
				t,
				"min",
				"max",
				"fit"
			] }],
			"max-w": [{ "max-w": [
				U,
				t,
				"none",
				"full",
				"min",
				"max",
				"fit",
				"prose",
				{ screen: [W] },
				W
			] }],
			h: [{ h: [
				U,
				t,
				"auto",
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			"min-h": [{ "min-h": [
				U,
				t,
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			"max-h": [{ "max-h": [
				U,
				t,
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			size: [{ size: [
				U,
				t,
				"auto",
				"min",
				"max",
				"fit"
			] }],
			"font-size": [{ text: [
				"base",
				W,
				z
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black",
				V
			] }],
			"font-family": [{ font: [K] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest",
				U
			] }],
			"line-clamp": [{ "line-clamp": [
				"none",
				B,
				V
			] }],
			leading: [{ leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose",
				R,
				U
			] }],
			"list-image": [{ "list-image": ["none", U] }],
			"list-style-type": [{ list: [
				"none",
				"disc",
				"decimal",
				U
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"placeholder-color": [{ placeholder: [e] }],
			"placeholder-opacity": [{ "placeholder-opacity": [_] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"text-color": [{ text: [e] }],
			"text-opacity": [{ "text-opacity": [_] }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...N(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				"auto",
				"from-font",
				R,
				z
			] }],
			"underline-offset": [{ "underline-offset": [
				"auto",
				R,
				U
			] }],
			"text-decoration-color": [{ decoration: [e] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: O() }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				U
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: ["none", U] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-opacity": [{ "bg-opacity": [_] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: [...M(), ne] }],
			"bg-repeat": [{ bg: ["no-repeat", { repeat: [
				"",
				"x",
				"y",
				"round",
				"space"
			] }] }],
			"bg-size": [{ bg: [
				"auto",
				"cover",
				"contain",
				te
			] }],
			"bg-image": [{ bg: [
				"none",
				{ "gradient-to": [
					"t",
					"tr",
					"r",
					"br",
					"b",
					"bl",
					"l",
					"tl"
				] },
				ie
			] }],
			"bg-color": [{ bg: [e] }],
			"gradient-from-pos": [{ from: [m] }],
			"gradient-via-pos": [{ via: [m] }],
			"gradient-to-pos": [{ to: [m] }],
			"gradient-from": [{ from: [p] }],
			"gradient-via": [{ via: [p] }],
			"gradient-to": [{ to: [p] }],
			rounded: [{ rounded: [a] }],
			"rounded-s": [{ "rounded-s": [a] }],
			"rounded-e": [{ "rounded-e": [a] }],
			"rounded-t": [{ "rounded-t": [a] }],
			"rounded-r": [{ "rounded-r": [a] }],
			"rounded-b": [{ "rounded-b": [a] }],
			"rounded-l": [{ "rounded-l": [a] }],
			"rounded-ss": [{ "rounded-ss": [a] }],
			"rounded-se": [{ "rounded-se": [a] }],
			"rounded-ee": [{ "rounded-ee": [a] }],
			"rounded-es": [{ "rounded-es": [a] }],
			"rounded-tl": [{ "rounded-tl": [a] }],
			"rounded-tr": [{ "rounded-tr": [a] }],
			"rounded-br": [{ "rounded-br": [a] }],
			"rounded-bl": [{ "rounded-bl": [a] }],
			"border-w": [{ border: [s] }],
			"border-w-x": [{ "border-x": [s] }],
			"border-w-y": [{ "border-y": [s] }],
			"border-w-s": [{ "border-s": [s] }],
			"border-w-e": [{ "border-e": [s] }],
			"border-w-t": [{ "border-t": [s] }],
			"border-w-r": [{ "border-r": [s] }],
			"border-w-b": [{ "border-b": [s] }],
			"border-w-l": [{ "border-l": [s] }],
			"border-opacity": [{ "border-opacity": [_] }],
			"border-style": [{ border: [...N(), "hidden"] }],
			"divide-x": [{ "divide-x": [s] }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": [s] }],
			"divide-y-reverse": ["divide-y-reverse"],
			"divide-opacity": [{ "divide-opacity": [_] }],
			"divide-style": [{ divide: N() }],
			"border-color": [{ border: [i] }],
			"border-color-x": [{ "border-x": [i] }],
			"border-color-y": [{ "border-y": [i] }],
			"border-color-s": [{ "border-s": [i] }],
			"border-color-e": [{ "border-e": [i] }],
			"border-color-t": [{ "border-t": [i] }],
			"border-color-r": [{ "border-r": [i] }],
			"border-color-b": [{ "border-b": [i] }],
			"border-color-l": [{ "border-l": [i] }],
			"divide-color": [{ divide: [i] }],
			"outline-style": [{ outline: ["", ...N()] }],
			"outline-offset": [{ "outline-offset": [R, U] }],
			"outline-w": [{ outline: [R, z] }],
			"outline-color": [{ outline: [e] }],
			"ring-w": [{ ring: A() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: [e] }],
			"ring-opacity": [{ "ring-opacity": [_] }],
			"ring-offset-w": [{ "ring-offset": [R, z] }],
			"ring-offset-color": [{ "ring-offset": [e] }],
			shadow: [{ shadow: [
				"",
				"inner",
				"none",
				W,
				ae
			] }],
			"shadow-color": [{ shadow: [K] }],
			opacity: [{ opacity: [_] }],
			"mix-blend": [{ "mix-blend": [
				...P(),
				"plus-lighter",
				"plus-darker"
			] }],
			"bg-blend": [{ "bg-blend": P() }],
			filter: [{ filter: ["", "none"] }],
			blur: [{ blur: [n] }],
			brightness: [{ brightness: [r] }],
			contrast: [{ contrast: [c] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				W,
				U
			] }],
			grayscale: [{ grayscale: [l] }],
			"hue-rotate": [{ "hue-rotate": [u] }],
			invert: [{ invert: [d] }],
			saturate: [{ saturate: [y] }],
			sepia: [{ sepia: [x] }],
			"backdrop-filter": [{ "backdrop-filter": ["", "none"] }],
			"backdrop-blur": [{ "backdrop-blur": [n] }],
			"backdrop-brightness": [{ "backdrop-brightness": [r] }],
			"backdrop-contrast": [{ "backdrop-contrast": [c] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [l] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [u] }],
			"backdrop-invert": [{ "backdrop-invert": [d] }],
			"backdrop-opacity": [{ "backdrop-opacity": [_] }],
			"backdrop-saturate": [{ "backdrop-saturate": [y] }],
			"backdrop-sepia": [{ "backdrop-sepia": [x] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": [o] }],
			"border-spacing-x": [{ "border-spacing-x": [o] }],
			"border-spacing-y": [{ "border-spacing-y": [o] }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"none",
				"all",
				"",
				"colors",
				"opacity",
				"shadow",
				"transform",
				U
			] }],
			duration: [{ duration: G() }],
			ease: [{ ease: [
				"linear",
				"in",
				"out",
				"in-out",
				U
			] }],
			delay: [{ delay: G() }],
			animate: [{ animate: [
				"none",
				"spin",
				"ping",
				"pulse",
				"bounce",
				U
			] }],
			transform: [{ transform: [
				"",
				"gpu",
				"none"
			] }],
			scale: [{ scale: [b] }],
			"scale-x": [{ "scale-x": [b] }],
			"scale-y": [{ "scale-y": [b] }],
			rotate: [{ rotate: [H, U] }],
			"translate-x": [{ "translate-x": [w] }],
			"translate-y": [{ "translate-y": [w] }],
			"skew-x": [{ "skew-x": [S] }],
			"skew-y": [{ "skew-y": [S] }],
			"transform-origin": [{ origin: [
				"center",
				"top",
				"top-right",
				"right",
				"bottom-right",
				"bottom",
				"bottom-left",
				"left",
				"top-left",
				U
			] }],
			accent: [{ accent: ["auto", e] }],
			appearance: [{ appearance: ["none", "auto"] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				U
			] }],
			"caret-color": [{ caret: [e] }],
			"pointer-events": [{ "pointer-events": ["none", "auto"] }],
			resize: [{ resize: [
				"none",
				"y",
				"x",
				""
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scroll-m": [{ "scroll-m": O() }],
			"scroll-mx": [{ "scroll-mx": O() }],
			"scroll-my": [{ "scroll-my": O() }],
			"scroll-ms": [{ "scroll-ms": O() }],
			"scroll-me": [{ "scroll-me": O() }],
			"scroll-mt": [{ "scroll-mt": O() }],
			"scroll-mr": [{ "scroll-mr": O() }],
			"scroll-mb": [{ "scroll-mb": O() }],
			"scroll-ml": [{ "scroll-ml": O() }],
			"scroll-p": [{ "scroll-p": O() }],
			"scroll-px": [{ "scroll-px": O() }],
			"scroll-py": [{ "scroll-py": O() }],
			"scroll-ps": [{ "scroll-ps": O() }],
			"scroll-pe": [{ "scroll-pe": O() }],
			"scroll-pt": [{ "scroll-pt": O() }],
			"scroll-pr": [{ "scroll-pr": O() }],
			"scroll-pb": [{ "scroll-pb": O() }],
			"scroll-pl": [{ "scroll-pl": O() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				U
			] }],
			fill: [{ fill: [e, "none"] }],
			"stroke-w": [{ stroke: [
				R,
				z,
				V
			] }],
			stroke: [{ stroke: [e, "none"] }],
			sr: ["sr-only", "not-sr-only"],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-s",
				"border-w-e",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-s",
				"border-color-e",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] }
	};
});
// src/utils/cn.ts
function J(...e) {
	return ue(a(e));
}
// src/components/Button.tsx
var de = c("inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50", {
	variants: {
		variant: {
			default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
			destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
			outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
			secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
			ghost: "hover:bg-accent hover:text-accent-foreground",
			link: "text-primary underline-offset-4 hover:underline"
		},
		size: {
			default: "h-9 px-4 py-2",
			sm: "h-8 rounded-md px-3 text-xs",
			lg: "h-10 rounded-md px-8",
			xl: "h-12 rounded-md px-10 text-base",
			touch: "h-12 min-w-12 rounded-lg px-4 text-base",
			icon: "h-9 w-9",
			"icon-sm": "h-8 w-8",
			"icon-lg": "h-10 w-10",
			"icon-touch": "h-12 w-12 rounded-lg"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
}), fe = e.forwardRef(({ className: e, variant: t, size: i, loading: a, disabled: o, children: s, ...c }, l) => /* @__PURE__ */ r("button", {
	className: J(de({
		variant: t,
		size: i,
		className: e
	})),
	ref: l,
	disabled: o || a,
	...c,
	children: [a && /* @__PURE__ */ r("svg", {
		className: "mr-2 h-4 w-4 animate-spin",
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		children: [/* @__PURE__ */ n("circle", {
			className: "opacity-25",
			cx: "12",
			cy: "12",
			r: "10",
			stroke: "currentColor",
			strokeWidth: "4"
		}), /* @__PURE__ */ n("path", {
			className: "opacity-75",
			fill: "currentColor",
			d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
		})]
	}), s]
}));
fe.displayName = "Button";
// src/components/Slider.tsx
var pe = e.forwardRef(({ className: t, value: i, defaultValue: a = 0, min: o = 0, max: s = 100, step: c = 1, onChange: l, showValue: u = !1, formatValue: d = (e) => String(e), disabled: f, ...p }, m) => {
	let [h, g] = e.useState(a), _ = i ?? h, v = (e) => {
		let t = parseFloat(e.target.value);
		g(t), l?.(t);
	}, y = (_ - o) / (s - o) * 100;
	return /* @__PURE__ */ r("div", {
		className: J("flex items-center gap-3", t),
		children: [/* @__PURE__ */ n("div", {
			className: "relative flex-1",
			children: /* @__PURE__ */ n("input", {
				ref: m,
				type: "range",
				min: o,
				max: s,
				step: c,
				value: _,
				onChange: v,
				disabled: f,
				className: J("w-full h-2 appearance-none bg-transparent cursor-pointer", "focus:outline-none focus-visible:ring-1 focus-visible:ring-ring", f && "cursor-not-allowed opacity-50", "[&::-webkit-slider-thumb]:appearance-none", "[&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:w-5", "[&::-webkit-slider-thumb]:rounded-full", "[&::-webkit-slider-thumb]:bg-primary", "[&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-background", "[&::-webkit-slider-thumb]:shadow-md", "[&::-webkit-slider-thumb]:transition-transform", "[&::-webkit-slider-thumb]:hover:scale-110", "[&::-moz-range-thumb]:h-5 [&::-moz-range-thumb]:w-5", "[&::-moz-range-thumb]:rounded-full", "[&::-moz-range-thumb]:bg-primary", "[&::-moz-range-thumb]:border-2 [&::-moz-range-thumb]:border-background"),
				style: { background: `linear-gradient(to right, hsl(var(--primary)) ${y}%, hsl(var(--muted)) ${y}%)` },
				...p
			})
		}), u && /* @__PURE__ */ n("span", {
			className: "min-w-[3rem] text-sm text-muted-foreground text-right",
			children: d(_)
		})]
	});
});
pe.displayName = "Slider";
// src/components/Card.tsx
var Y = e.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ n("div", {
	ref: r,
	className: J("rounded-xl border bg-card text-card-foreground shadow", e),
	...t
}));
Y.displayName = "Card";
var me = e.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ n("div", {
	ref: r,
	className: J("flex flex-col space-y-1.5 p-6", e),
	...t
}));
me.displayName = "CardHeader";
var he = e.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ n("h3", {
	ref: r,
	className: J("font-semibold leading-none tracking-tight", e),
	...t
}));
he.displayName = "CardTitle";
var ge = e.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ n("p", {
	ref: r,
	className: J("text-sm text-muted-foreground", e),
	...t
}));
ge.displayName = "CardDescription";
var X = e.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ n("div", {
	ref: r,
	className: J("p-6 pt-0", e),
	...t
}));
X.displayName = "CardContent";
var _e = e.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ n("div", {
	ref: r,
	className: J("flex items-center p-6 pt-0", e),
	...t
}));
_e.displayName = "CardFooter";
// src/components/ImageUploader.tsx
var ve = e.forwardRef(({ accept: t = "image/jpeg,image/png,image/webp,image/gif", maxSize: i = 52428800, multiple: a = !1, onUpload: o, onError: s, className: c, disabled: l = !1 }, u) => {
	let [d, f] = e.useState(!1), p = e.useRef(null), m = (e) => {
		if (!e || e.length === 0) return [];
		let n = [], r = t.split(",").map((e) => e.trim());
		for (let t = 0; t < e.length; t++) {
			let o = e[t];
			if (!r.some((e) => o.type.match(e.replace("*", ".*")))) s?.(`File type not supported: ${o.type}`);
			else if (o.size > i) s?.(`File too large: ${(o.size / 1024 / 1024).toFixed(2)}MB (max ${i / 1024 / 1024}MB)`);
			else if (n.push(o), !a) break;
		}
		return n;
	}, h = (e) => {
		let t = m(e);
		t.length > 0 && o?.(t);
	};
	return /* @__PURE__ */ r("div", {
		ref: u,
		className: J("relative flex flex-col items-center justify-center", "w-full min-h-[200px] p-8", "border-2 border-dashed rounded-lg", "transition-colors cursor-pointer", d ? "border-primary bg-primary/5" : "border-muted-foreground/25 hover:border-muted-foreground/50", l && "opacity-50 cursor-not-allowed", c),
		onClick: () => {
			l || p.current?.click();
		},
		onDragOver: (e) => {
			e.preventDefault(), e.stopPropagation(), l || f(!0);
		},
		onDragLeave: (e) => {
			e.preventDefault(), e.stopPropagation(), f(!1);
		},
		onDrop: (e) => {
			e.preventDefault(), e.stopPropagation(), f(!1), l || h(e.dataTransfer.files);
		},
		children: [
			/* @__PURE__ */ n("input", {
				ref: p,
				type: "file",
				accept: t,
				multiple: a,
				onChange: (e) => {
					h(e.target.files), e.target.value = "";
				},
				disabled: l,
				className: "hidden"
			}),
			/* @__PURE__ */ n("svg", {
				className: "w-12 h-12 mb-4 text-muted-foreground",
				fill: "none",
				stroke: "currentColor",
				viewBox: "0 0 24 24",
				children: /* @__PURE__ */ n("path", {
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5,
					d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
				})
			}),
			/* @__PURE__ */ r("p", {
				className: "mb-2 text-sm text-muted-foreground",
				children: [/* @__PURE__ */ n("span", {
					className: "font-semibold",
					children: "Click to upload"
				}), " or drag and drop"]
			}),
			/* @__PURE__ */ r("p", {
				className: "text-xs text-muted-foreground",
				children: [
					"PNG, JPG, WebP or GIF (max ",
					i / 1024 / 1024,
					"MB)"
				]
			})
		]
	});
});
ve.displayName = "ImageUploader";
// src/components/Tabs.tsx
var ye = e.createContext(null);
function be() {
	let t = e.useContext(ye);
	if (!t) throw Error("Tabs components must be used within a Tabs provider");
	return t;
}
var xe = e.forwardRef(({ className: t, value: r, defaultValue: i, onValueChange: a, children: o, ...s }, c) => {
	let [l, u] = e.useState(i ?? ""), d = r ?? l;
	return /* @__PURE__ */ n(ye.Provider, {
		value: {
			value: d,
			onValueChange: (e) => {
				u(e), a?.(e);
			}
		},
		children: /* @__PURE__ */ n("div", {
			ref: c,
			className: J("w-full", t),
			...s,
			children: o
		})
	});
});
xe.displayName = "Tabs";
var Se = e.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ n("div", {
	ref: r,
	className: J("inline-flex h-9 items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground", e),
	...t
}));
Se.displayName = "TabsList";
var Ce = e.forwardRef(({ className: e, value: t, ...r }, i) => {
	let { value: a, onValueChange: o } = be(), s = a === t;
	return /* @__PURE__ */ n("button", {
		ref: i,
		type: "button",
		role: "tab",
		"aria-selected": s,
		className: J("inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1", "text-sm font-medium ring-offset-background transition-all", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", "disabled:pointer-events-none disabled:opacity-50", s ? "bg-background text-foreground shadow" : "hover:bg-background/50", e),
		onClick: () => o(t),
		...r
	});
});
Ce.displayName = "TabsTrigger";
var we = e.forwardRef(({ className: e, value: t, ...r }, i) => {
	let { value: a } = be();
	return a === t ? /* @__PURE__ */ n("div", {
		ref: i,
		role: "tabpanel",
		className: J("mt-2 ring-offset-background", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", e),
		...r
	}) : null;
});
we.displayName = "TabsContent";
// src/components/Dialog.tsx
var Te = e.createContext(null);
function Z() {
	let t = e.useContext(Te);
	if (!t) throw Error("Dialog components must be used within a Dialog provider");
	return t;
}
function Ee({ open: t, defaultOpen: r = !1, onOpenChange: i, children: a }) {
	let [o, s] = e.useState(r), c = t ?? o;
	return /* @__PURE__ */ n(Te.Provider, {
		value: {
			open: c,
			onOpenChange: (e) => {
				s(e), i?.(e);
			}
		},
		children: a
	});
}
var De = e.forwardRef(({ onClick: e, children: t, ...r }, i) => {
	let { onOpenChange: a } = Z();
	return /* @__PURE__ */ n("button", {
		ref: i,
		type: "button",
		onClick: (t) => {
			e?.(t), a(!0);
		},
		...r,
		children: t
	});
});
De.displayName = "DialogTrigger";
var Oe = ({ children: e }) => {
	let { open: r } = Z();
	return r ? /* @__PURE__ */ n(t, { children: e }) : null;
}, Q = e.forwardRef(({ className: e, ...t }, r) => {
	let { onOpenChange: i } = Z();
	return /* @__PURE__ */ n("div", {
		ref: r,
		className: J("fixed inset-0 z-[60] bg-black/80", "data-[state=open]:animate-in data-[state=closed]:animate-out", "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", e),
		onClick: () => i(!1),
		...t
	});
});
Q.displayName = "DialogOverlay";
var ke = e.forwardRef(({ className: t, children: i, ...a }, o) => {
	let { open: s, onOpenChange: c } = Z();
	return e.useEffect(() => {
		let e = (e) => {
			e.key === "Escape" && c(!1);
		};
		return s && (document.addEventListener("keydown", e), document.body.style.overflow = "hidden"), () => {
			document.removeEventListener("keydown", e), document.body.style.overflow = "";
		};
	}, [s, c]), s ? /* @__PURE__ */ r(Oe, { children: [/* @__PURE__ */ n(Q, {}), /* @__PURE__ */ r("div", {
		ref: o,
		className: J("fixed left-[50%] top-[50%] z-[60] grid w-full max-w-lg", "translate-x-[-50%] translate-y-[-50%] gap-4", "border bg-background p-6 shadow-lg", "duration-200", "sm:rounded-lg", t),
		onClick: (e) => e.stopPropagation(),
		...a,
		children: [i, /* @__PURE__ */ r("button", {
			className: J("absolute right-4 top-4 rounded-sm opacity-70", "ring-offset-background transition-opacity", "hover:opacity-100", "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", "disabled:pointer-events-none"),
			onClick: () => c(!1),
			children: [/* @__PURE__ */ n("svg", {
				className: "h-4 w-4",
				fill: "none",
				stroke: "currentColor",
				viewBox: "0 0 24 24",
				children: /* @__PURE__ */ n("path", {
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 2,
					d: "M6 18L18 6M6 6l12 12"
				})
			}), /* @__PURE__ */ n("span", {
				className: "sr-only",
				children: "Close"
			})]
		})]
	})] }) : null;
});
ke.displayName = "DialogContent";
var Ae = ({ className: e, ...t }) => /* @__PURE__ */ n("div", {
	className: J("flex flex-col space-y-1.5 text-center sm:text-left", e),
	...t
});
Ae.displayName = "DialogHeader";
var je = ({ className: e, ...t }) => /* @__PURE__ */ n("div", {
	className: J("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", e),
	...t
});
je.displayName = "DialogFooter";
var Me = e.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ n("h2", {
	ref: r,
	className: J("text-lg font-semibold leading-none tracking-tight", e),
	...t
}));
Me.displayName = "DialogTitle";
var Ne = e.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ n("p", {
	ref: r,
	className: J("text-sm text-muted-foreground", e),
	...t
}));
Ne.displayName = "DialogDescription";
// src/components/Progress.tsx
var Pe = e.forwardRef(({ className: e, value: t = 0, max: i = 100, showValue: a = !1, indeterminate: o = !1, ...s }, c) => {
	let l = Math.min(100, Math.max(0, t / i * 100));
	return /* @__PURE__ */ r("div", {
		className: J("flex items-center gap-3", e),
		children: [/* @__PURE__ */ n("div", {
			ref: c,
			role: "progressbar",
			"aria-valuenow": o ? void 0 : t,
			"aria-valuemin": 0,
			"aria-valuemax": i,
			className: J("relative h-2 w-full overflow-hidden rounded-full bg-primary/20"),
			...s,
			children: /* @__PURE__ */ n("div", {
				className: J("h-full bg-primary transition-all duration-300", o && "animate-progress-indeterminate"),
				style: o ? void 0 : { width: `${l}%` }
			})
		}), a && !o && /* @__PURE__ */ r("span", {
			className: "min-w-[3rem] text-sm text-muted-foreground text-right",
			children: [Math.round(l), "%"]
		})]
	});
});
Pe.displayName = "Progress";
// src/components/TemplateGrid.tsx
var Fe = {
	2: "grid-cols-2",
	3: "grid-cols-3",
	4: "grid-cols-2 sm:grid-cols-3 md:grid-cols-4",
	5: "grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5",
	6: "grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6"
}, Ie = e.forwardRef(({ templates: e, selectedId: t, onSelect: i, columns: a = 4, showPremiumBadge: o = !0, hasPremiumAccess: s = !1, loading: c = !1, emptyMessage: l = "No templates found", className: u }, d) => c ? /* @__PURE__ */ n("div", {
	ref: d,
	className: J("grid gap-3", Fe[a], u),
	children: Array.from({ length: 8 }).map((e, t) => /* @__PURE__ */ n("div", { className: "aspect-square rounded-lg bg-muted animate-pulse" }, t))
}) : e.length === 0 ? /* @__PURE__ */ n("div", {
	ref: d,
	className: J("flex items-center justify-center p-8 text-muted-foreground", u),
	children: l
}) : /* @__PURE__ */ n("div", {
	ref: d,
	className: J("grid gap-3", Fe[a], u),
	children: e.map((e) => {
		let a = e.id === t, c = e.isPremium && !s;
		return /* @__PURE__ */ r("button", {
			type: "button",
			onClick: () => !c && i?.(e),
			disabled: c,
			className: J("group relative aspect-square overflow-hidden rounded-lg", "border-2 transition-all", "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring", a ? "border-primary ring-2 ring-primary/20" : "border-transparent hover:border-muted-foreground/30", c && "cursor-not-allowed opacity-60"),
			children: [
				/* @__PURE__ */ n("img", {
					src: e.thumbnailUrl,
					alt: e.name,
					className: "h-full w-full object-cover transition-transform group-hover:scale-105",
					loading: "lazy"
				}),
				/* @__PURE__ */ n("div", {
					className: J("absolute inset-x-0 bottom-0", "bg-gradient-to-t from-black/70 to-transparent", "p-2 pt-8"),
					children: /* @__PURE__ */ n("span", {
						className: "text-xs text-white font-medium line-clamp-1",
						children: e.name
					})
				}),
				o && e.isPremium && /* @__PURE__ */ n("div", {
					className: J("absolute top-2 right-2", "px-1.5 py-0.5 rounded text-[10px] font-semibold", s ? "bg-primary text-primary-foreground" : "bg-amber-500 text-white"),
					children: "PRO"
				}),
				c && /* @__PURE__ */ n("div", {
					className: "absolute inset-0 flex items-center justify-center bg-black/40",
					children: /* @__PURE__ */ n("svg", {
						className: "w-8 h-8 text-white",
						fill: "none",
						stroke: "currentColor",
						viewBox: "0 0 24 24",
						children: /* @__PURE__ */ n("path", {
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 2,
							d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
						})
					})
				}),
				a && /* @__PURE__ */ n("div", {
					className: "absolute top-2 left-2 w-5 h-5 rounded-full bg-primary flex items-center justify-center",
					children: /* @__PURE__ */ n("svg", {
						className: "w-3 h-3 text-primary-foreground",
						fill: "none",
						stroke: "currentColor",
						viewBox: "0 0 24 24",
						children: /* @__PURE__ */ n("path", {
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 3,
							d: "M5 13l4 4L19 7"
						})
					})
				})
			]
		}, e.id);
	})
}));
Ie.displayName = "TemplateGrid";
// src/components/Switch.tsx
var Le = e.forwardRef(({ checked: t, defaultChecked: r = !1, onCheckedChange: i, disabled: a = !1, className: o, "aria-label": s }, c) => {
	let [l, u] = e.useState(r), d = t !== void 0, f = d ? t : l;
	return /* @__PURE__ */ n("button", {
		ref: c,
		type: "button",
		role: "switch",
		"aria-checked": f,
		"aria-label": s,
		disabled: a,
		onClick: () => {
			if (a) return;
			let e = !f;
			d || u(e), i?.(e);
		},
		className: J("relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full", "border-2 border-transparent transition-colors", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2", "disabled:cursor-not-allowed disabled:opacity-50", f ? "bg-primary" : "bg-muted", o),
		children: /* @__PURE__ */ n("span", { className: J("pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform", f ? "translate-x-5" : "translate-x-0") })
	});
});
Le.displayName = "Switch";
// src/components/Sheet.tsx
var $ = [
	30,
	60,
	90
], Re = e.createContext(null);
function ze() {
	let t = e.useContext(Re);
	if (!t) throw Error("Sheet components must be used within a Sheet provider");
	return t;
}
function Be({ open: t, defaultOpen: r = !1, onOpenChange: i, defaultSnapPoint: a = 60, children: o }) {
	let [s, c] = e.useState(r), [l, u] = e.useState(a), d = t ?? s;
	return /* @__PURE__ */ n(Re.Provider, {
		value: {
			open: d,
			onOpenChange: (e) => {
				c(e), i?.(e);
			},
			snapPoint: l,
			setSnapPoint: u
		},
		children: o
	});
}
var Ve = e.forwardRef(({ onClick: e, children: t, ...r }, i) => {
	let { onOpenChange: a } = ze();
	return /* @__PURE__ */ n("button", {
		ref: i,
		type: "button",
		onClick: (t) => {
			e?.(t), a(!0);
		},
		...r,
		children: t
	});
});
Ve.displayName = "SheetTrigger";
var He = e.forwardRef(({ className: e, ...t }, r) => {
	let { onOpenChange: i } = ze();
	return /* @__PURE__ */ n("div", {
		ref: r,
		className: J("fixed inset-0 z-40 bg-black/50", e),
		onClick: () => i(!1),
		...t
	});
});
He.displayName = "SheetOverlay";
var Ue = e.forwardRef(({ className: i, children: a, showOverlay: o = !0, draggable: s = !0, ...c }, l) => {
	let { open: u, onOpenChange: d, snapPoint: f, setSnapPoint: p } = ze(), m = e.useRef(null), [h, g] = e.useState(!1), [_, v] = e.useState(null), y = e.useRef(0), b = e.useRef(0);
	e.useEffect(() => {
		let e = (e) => {
			e.key === "Escape" && d(!1);
		};
		return u && (document.addEventListener("keydown", e), document.body.style.overflow = "hidden"), () => {
			document.removeEventListener("keydown", e), document.body.style.overflow = "";
		};
	}, [u, d]);
	let x = (e) => {
		s && (g(!0), y.current = e, b.current = m.current?.offsetHeight ?? 0);
	}, S = e.useCallback((e) => {
		if (!h) return;
		let t = y.current - e, n = Math.max(100, Math.min(window.innerHeight * .95, b.current + t));
		v(n);
	}, [h]), C = e.useCallback(() => {
		if (!h) return;
		g(!1);
		let e = (_ ?? b.current) / window.innerHeight * 100, t = $[0], n = Math.abs(e - $[0]);
		for (let r of $) {
			let i = Math.abs(e - r);
			i < n && (n = i, t = r);
		}
		e < 15 ? d(!1) : p(t), v(null);
	}, [
		h,
		_,
		d,
		p
	]);
	if (e.useEffect(() => {
		if (!h) return;
		let e = (e) => S(e.clientY), t = () => C();
		return document.addEventListener("mousemove", e), document.addEventListener("mouseup", t), () => {
			document.removeEventListener("mousemove", e), document.removeEventListener("mouseup", t);
		};
	}, [
		h,
		S,
		C
	]), e.useEffect(() => {
		if (!h) return;
		let e = (e) => {
			e.preventDefault(), S(e.touches[0].clientY);
		}, t = () => C();
		return document.addEventListener("touchmove", e, { passive: !1 }), document.addEventListener("touchend", t), () => {
			document.removeEventListener("touchmove", e), document.removeEventListener("touchend", t);
		};
	}, [
		h,
		S,
		C
	]), !u) return null;
	let w = _ ?? `${f}vh`;
	return /* @__PURE__ */ r(t, { children: [o && /* @__PURE__ */ n(He, {}), /* @__PURE__ */ r("div", {
		ref: (e) => {
			m.current = e, typeof l == "function" ? l(e) : l && (l.current = e);
		},
		className: J("fixed inset-x-0 bottom-0 z-50", "border-t bg-background shadow-lg", "rounded-t-xl", !h && "transition-[height] duration-200 ease-out", i),
		style: { height: w },
		onClick: (e) => e.stopPropagation(),
		...c,
		children: [s && /* @__PURE__ */ n("div", {
			className: "flex h-6 w-full cursor-grab items-center justify-center active:cursor-grabbing",
			onMouseDown: (e) => x(e.clientY),
			onTouchStart: (e) => x(e.touches[0].clientY),
			children: /* @__PURE__ */ n("div", { className: "h-1 w-12 rounded-full bg-muted-foreground/30" })
		}), /* @__PURE__ */ n("div", {
			className: "flex h-[calc(100%-1.5rem)] flex-col overflow-hidden",
			children: a
		})]
	})] });
});
Ue.displayName = "SheetContent";
var We = ({ className: e, ...t }) => /* @__PURE__ */ n("div", {
	className: J("flex flex-col space-y-1.5 px-4 pb-2", e),
	...t
});
We.displayName = "SheetHeader";
var Ge = e.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ n("h2", {
	ref: r,
	className: J("text-lg font-semibold leading-none tracking-tight", e),
	...t
}));
Ge.displayName = "SheetTitle";
var Ke = e.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ n("p", {
	ref: r,
	className: J("text-sm text-muted-foreground", e),
	...t
}));
Ke.displayName = "SheetDescription";
// src/components/CollapsibleCard.tsx
function qe({ title: t, collapsible: i = !1, defaultCollapsed: a = !0, className: o, contentClassName: s, disabled: c = !1, children: l }) {
	let [u, d] = e.useState(!a), f = !i || u;
	return /* @__PURE__ */ n(Y, {
		className: J(c && "opacity-50 pointer-events-none", o),
		children: /* @__PURE__ */ r(X, {
			className: J("p-4 space-y-4", s),
			children: [/* @__PURE__ */ r("button", {
				type: "button",
				className: J("flex w-full items-center justify-between text-sm font-medium", i && "cursor-pointer"),
				onClick: () => i && d(!u),
				disabled: !i,
				children: [/* @__PURE__ */ n("span", { children: t }), i && /* @__PURE__ */ n("svg", {
					className: J("h-4 w-4 transition-transform", u && "rotate-180"),
					fill: "none",
					stroke: "currentColor",
					viewBox: "0 0 24 24",
					children: /* @__PURE__ */ n("path", {
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 2,
						d: "M19 9l-7 7-7-7"
					})
				})]
			}), f && /* @__PURE__ */ n("div", {
				className: "space-y-4",
				children: l
			})]
		})
	});
}
export { fe as Button, Y as Card, X as CardContent, ge as CardDescription, _e as CardFooter, me as CardHeader, he as CardTitle, qe as CollapsibleCard, Ee as Dialog, ke as DialogContent, Ne as DialogDescription, je as DialogFooter, Ae as DialogHeader, Q as DialogOverlay, Oe as DialogPortal, Me as DialogTitle, De as DialogTrigger, ve as ImageUploader, Pe as Progress, Be as Sheet, Ue as SheetContent, Ke as SheetDescription, We as SheetHeader, He as SheetOverlay, Ge as SheetTitle, Ve as SheetTrigger, pe as Slider, Le as Switch, xe as Tabs, we as TabsContent, Se as TabsList, Ce as TabsTrigger, Ie as TemplateGrid, de as buttonVariants, J as cn };

//# sourceMappingURL=index.js.map